import { localeInitial } from './locale';
import { screenInitial } from './screen';
import { userInitial } from './user';
import { routeinitial } from './route';
import type { GlobalContextReducerState } from './types';
import { activeFeatureConfigInitial } from './activeFeatureConfig';
import { Portal } from '@dfg/brahma-types';
import { navItemsInitial } from './navItems';
import { currentVRCountryInitial } from './currentVRCountry';
import { coBrandDetailsInitial } from './coBrandDetails';

export const defaultState: GlobalContextReducerState = {
  screen: screenInitial,
  locale: localeInitial,
  user: userInitial,
  route: routeinitial,
  activeFeatureConfig: activeFeatureConfigInitial,
  portal: Portal.APPLICANT,
  navItems: navItemsInitial,
  currentVRCountry: currentVRCountryInitial,
  coBrandDetails: coBrandDetailsInitial
};
